import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { JobsOffer } from '../models/jobs-offer';

@Component({
  selector: 'app-view-cv',
  templateUrl: './view-cv.component.html',
  styleUrls: ['./view-cv.component.css']
})

export class ViewCvComponent implements OnInit {

  userId: string;
  job: JobsOffer;

  constructor(public dialogRef: MatDialogRef<ViewCvComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userId = data.userId;
    this.job = data.job;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/view-cv/view-cv.component.ts